import styles from './SortSelect.module.css';

const SORT_OPTIONS = [
  { value: 'relevance', label: 'По релевантности' },
  { value: 'new', label: 'Сначала новые' },
  { value: 'name_asc', label: 'По алфавиту А–Я' },
  { value: 'name_desc', label: 'По алфавиту Я–А' },
  { value: 'price_asc', label: 'Сначала дешёвые' },
  { value: 'price_desc', label: 'Сначала дорогие' },
];

export function SortSelect({ value, onChange }) {
  return (
    <div className={styles.wrap}>
      <label htmlFor="sort" className={styles.label}>
        Сортировка
      </label>
      <select id="sort" className={styles.select} value={value} onChange={(e) => onChange(e.target.value)}>
        {SORT_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export { SORT_OPTIONS };
